/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';

/**
 * 
 * @export
 * @interface UpdateUpgradeStatusDto
 */
export interface UpdateUpgradeStatusDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateUpgradeStatusDto
     */
    exitCode?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    remedyMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UpdateUpgradeStatusDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    fromVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    targetVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    $type?: UpdateUpgradeStatusDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateUpgradeStatusDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoUpdateUpgradeStatusDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.UpdateUpgradeStatusDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateUpgradeStatusDtoTypeEnum = typeof UpdateUpgradeStatusDtoTypeEnum[keyof typeof UpdateUpgradeStatusDtoTypeEnum];



/**
 * Check if a given object implements the UpdateUpgradeStatusDto interface.
 */
export function instanceOfUpdateUpgradeStatusDto(value?: unknown): value is UpdateUpgradeStatusDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateUpgradeStatusDtoTypeEnum)[0];
}

export function UpdateUpgradeStatusDtoFromJSON(json: any): UpdateUpgradeStatusDto {
    return UpdateUpgradeStatusDtoFromJSONTyped(json, false);
}

export function UpdateUpgradeStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUpgradeStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'exitCode': json['exitCode'] == null ? undefined : json['exitCode'],
        'remedyMessage': json['remedyMessage'] == null ? undefined : json['remedyMessage'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'creatorUser': json['creatorUser'] == null ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'fromVersion': json['fromVersion'] == null ? undefined : json['fromVersion'],
        'targetVersion': json['targetVersion'] == null ? undefined : json['targetVersion'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UpdateUpgradeStatusDtoToJSON(value?: UpdateUpgradeStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exitCode': value['exitCode'],
        'remedyMessage': value['remedyMessage'],
        'errorMessage': value['errorMessage'],
        'creatorUser': HistoryDtoUserToJSON(value['creatorUser']),
        'fromVersion': value['fromVersion'],
        'targetVersion': value['targetVersion'],
        '$type': value['$type'],
    });
}

